import SimpleLightbox from "simplelightbox";
import 'simplelightbox/dist/simple-lightbox.min.css';

const gallery = document.querySelector('.gallery');
const loader = document.querySelector('.loader');
const loaderText = document.querySelector('.loader-text');
const loadMoreBtn = document.querySelector('.load-more-btn');

const lightbox = new SimpleLightbox('.gallery a', {
    captionsData: 'alt',
    captionDelay: 250,
});

export function createGallery(images) {
    if (!gallery) return;
    const markup = images
        .map(
            image => `
        <li class="gallery-item">
        <a href="${image.largeImageURL}"> 
        <img src="${image.webformatURL}" alt="${image.tags}" loading="lazy" />
        <div class="info">
            <p><b>Likes:</b> ${image.likes}</p>
            <p><b>Views:</b> ${image.views}</p>
            <p><b>Comments:</b> ${image.comments}</p>
            <p><b>Downloads:</b> ${image.downloads}</p>
        </div>
        </a>
        </li>`
    )
    .join('');
    
    gallery.insertAdjacentHTML('beforeend', markup);
    lightbox.refresh();
}

export function clearGallery() {
    gallery.innerHTML = '';
}

export function showLoader() {
    loader.classList.remove('is-hidden'); 
    loader.style.display = 'block';
    loaderText.style.display = 'block';
}

export function hideLoader() {
    loader.classList.add('is-hidden'); 
    loader.style.display = 'none';
    loaderText.style.display = 'none';
}

export function showLoadMoreButton() {
    loadMoreBtn.classList.remove('is-hidden');
}

export function hideLoadMoreButton() {
    loadMoreBtn.classList.add('is-hidden');
}

export function smoothScroll() {
    const card = document.querySelector('.gallery-item');
    if (!card) return;

   
    const { height } = card.getBoundingClientRect();

    window.scrollBy({
        top: height * 2,
        behavior: 'smooth'
    });
}